import { useEffect, useState } from "react";
import { iamService, usersService } from "../../services";
import { Role, User } from "@bluefalcon/users-management-client-fetch";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingSpinner } from "@bluefalcon/components-package";
import { RolesQuickView } from "../../components/roles-quick-view/roles-quick-view.comp";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";

export function UserDetails() {

    const { userId } = useParams();
    const [user, setUser] = useState<User | undefined>(undefined);
    const [roles, setRoles] = useState<Role[]>([]);
    const navigate = useNavigate();

    const getUserById = async () => {
        if (!userId) {
            navigate('/');
            return;
        }
        try {
            const foundUser = await usersService.getUserById(userId);
            setUser(foundUser);
        } catch (e: any) {
            navigate('/');
        }
    };

    const fetchRoles = async () => {
        const { results } = await iamService.searchRoles({});
        setRoles(results);
    };

    useEffect(() => {
        getUserById();
        fetchRoles();
    }, []);

    if (!user) {
        return <LoadingSpinner />;
    }

    return (
        <Box p={4}>
            <Flex mb={4}>
                <Heading as="h1">User Details</Heading>
            </Flex>
            <Box
                borderWidth="1px"
                borderRadius="lg"
                p={6}
                boxShadow="md"
                mb={6}
                bg="white"
            >
                <Flex mb={4}>
                    <Text fontWeight="bold" mr={2}>
                        First Name:
                    </Text>
                    <Text>{user.firstName || 'N/A'}</Text>
                </Flex>
                <Flex mb={4}>
                    <Text fontWeight="bold" mr={2}>
                        Last Name:
                    </Text>
                    <Text>{user.lastName || 'N/A'}</Text>
                </Flex>
                <Flex mb={4}>
                    <Text fontWeight="bold" mr={2}>
                        Email:
                    </Text>
                    <Text>{user.email || 'N/A'}</Text>
                </Flex>
                <Flex>
                    <Text fontWeight="bold" mr={2}>
                        Nickname:
                    </Text>
                    <Text>{user.nickname || 'N/A'}</Text>
                </Flex>
            </Box>
            <RolesQuickView user={user} roles={roles} />
        </Box>
    );
};
